import React from "react"

export default function Copy() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
         <path fillRule="evenodd" clipRule="evenodd" d="M10.769 5.7688H4.02034C3.51419 5.7688 3.17676 6.1063 3.17676 6.61255V15.05C3.17676 15.5563 3.51419 15.8938 4.02034 15.8938H10.769C11.2752 15.8938 11.6126 15.5563 11.6126 15.05V6.61255C11.6126 6.1063 11.2752 5.7688 10.769 5.7688Z" fill="#5B5E71" />
         <path fillRule="evenodd" clipRule="evenodd" d="M14.1434 2.3938H5.70752V4.0813H13.2998V13.3625H14.9869V3.23755C14.9869 2.7313 14.6495 2.3938 14.1434 2.3938Z" fill="#5B5E71" />
      </svg>
   )
}
